
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/membership/terms-and-conditions",
      function () {
        return require("private-next-pages/membership/terms-and-conditions.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/membership/terms-and-conditions"])
      });
    }
  